<template>
  <div id="service" class="animated bounceInUp" v-if="page !== ''">
    <div class="grid-container fluid no-padding">
      <div id="hero">
        <h4>{{ $t('service.title') }}</h4>
        <h1>{{ $t(`service.${page}.title`) }}</h1>
        <router-link tag="button" class="button c-1" :to="{name: 'Home'}">&#8617; {{ $t('etc.backToHome') }}</router-link>
      </div>
    </div>
    <div class="grid-container margin-huge-top margin-huge-bottom">
      <div class="grid-x grid-margin-x">
        <service-focus 
        v-for="(point, index) in $t(`service.${page}.sellingpoint`)"
        :key="index"
        :topic="point[0]"
        :explain="point[1]"/>
      </div>
      <div class="grid-x grid-margin-x">
        <service-card 
        :uid="page"
        :slide="getImageCollection"/>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceCard from '@/components/ServiceCard'
import ServiceFocus from '@/components/ServiceFocus'
export default {
  name: 'Service',
  metaInfo: {
    title: 'Service'
  },
  components: {ServiceCard, ServiceFocus},
  mounted () {
    this.page = this.$route.params.page
  },
  data () {
    return {
      page: '',
      imageCollection: '',
      services: {
        warehouse: {
          slide: [
            require('../assets/img/service-warehouse.jpg')
          ]
        },
        transportation: {
          slide: [
            require('../assets/img/service-transportation.jpg')
          ]
        },
        shipping: {
        },
        freight: {
        }
      }
    }
  },
  computed: {
    getImageCollection () {
      return this.services[this.page].slide
    }
  }
}
</script>

<style lang="scss" scoped>
#service {
  opacity: 1;
  #hero {
    padding: 6em 1em;
    background-image: url('../assets/img/service-bg.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
}
</style>

